<template>
    <div class="position-management">
        <!-- 页面头部 -->
        <div class="header">
            <div class="header-left">
                <button class="back-btn" @click="goBack">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="title">枚举值管理</div>
            </div>
        </div>

        <!-- 操作工具栏 -->
        <div class="toolbar">
            <div class="toolbar-right">
                <div style="width: 100%;display: flex; align-items: center; justify-content: flex-end; gap: 10px;">
                    <button class="btn btn-primary" @click="openAddModal">新增</button>
                </div>
            </div>
        </div>

        <!-- 内容列表 -->
        <div class="content-table-container">
            <el-table :data="items" style="width: 100%" empty-text="暂无数据" v-loading="loading"
                height="calc(100vh - 160px)">
                <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
                <el-table-column prop="noticeText" label="通知文本" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="liberayIds" label="liberay IDs" min-width="160"
                    show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="liberayNote" label="liberay 备注" min-width="160"
                    show-overflow-tooltip></el-table-column> -->
                <!-- <el-table-column prop="isActive" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isActive ? 'success' : 'danger'" size="small">{{ scope.row.isActive ?
                            '启用' : '禁用' }}</el-tag>
                    </template></el-table-column> -->
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="openEditModal(scope.row)">编辑</el-button>
                        <!-- <el-button size="mini" type="warning" @click="toggleStatus(scope.row)">{{ scope.row.isActive ?
                            '禁用' : '启用' }}</el-button>
                        <el-button size="mini" type="danger" @click="deleteItem(scope.row.id)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination" v-if="totalPages > 1">
                <button @click="prevPage" :disabled="currentPage <= 0">上一页</button>
                <span>{{ currentPage + 1 }} / {{ totalPages }}</span>
                <button @click="nextPage" :disabled="currentPage >= totalPages - 1">下一页</button>
            </div>
        </div>

        <!-- 新增/编辑模态框 -->
        <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
            <div class="modal-content" @click.stop>
                <h3>{{ isEditMode ? '编辑枚举值' : '新增枚举值' }}</h3>
                <div style="height: calc(100vh - 200px);overflow-y: auto;">
                    <div class="form-group">
                        <label>通知文本:</label>
                        <el-input v-model="current.noticeText" clearable />
                    </div>

                    <div class="form-group">
                        <label>liberay IDs:</label>
                        <el-input v-model="current.liberayIds" clearable />
                    </div>

                    <div class="form-group">
                        <label>liberay 备注:</label>
                        <el-input v-model="current.liberayNote" clearable />
                    </div>

                    <div class="form-group">
                        <label>路由数组（JSON 字符串）: <i class="el-icon-plus" @click="addRouter"></i></label>
                        <div>
                            <div v-for="(item, index) in current.routerArr" :key="index" style="border: 1px solid #ccc;margin-bottom: 10px;
                                border-radius: 8px;display: flex;flex-direction: column;gap: 10px;padding: 10px;">
                                <div style="display: flex; align-items: center;">
                                    <span style="width: 40px;">路径</span>
                                    <el-input v-model="item.path" clearable style="flex: 1;" />
                                    <div>管理员
                                        <el-radio-group v-model="item.isAdminOnly">
                                            <el-radio :label="true">是</el-radio>
                                            <el-radio :label="false">否</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div style="display: flex; align-items: center;">
                                    <span style="width: 40px;">标题</span>
                                    <el-input v-model="item.title" clearable style="flex: 1;" />
                                    <div>要显示
                                        <el-radio-group v-model="item.isShow">
                                            <el-radio :label="true">是</el-radio>
                                            <el-radio :label="false">否</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>准备文本（富文本）:</label>
                        <div class="content-editor-wrapper">
                            <quill-editor v-model="current.prepareText" :options="editorOption"
                                class="content-quill-editor" style="min-height: 260px;"></quill-editor>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>开始文本（富文本）:</label>
                        <div class="content-editor-wrapper">
                            <quill-editor v-model="current.startText" :options="editorOption"
                                class="content-quill-editor" style="min-height: 260px;"></quill-editor>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>最新活动（富文本）:</label>
                        <div class="content-editor-wrapper">
                            <quill-editor v-model="current.latestActivityText" :options="editorOption"
                                class="content-quill-editor" style="min-height: 260px;"></quill-editor>
                        </div>
                    </div>
                </div>

                <div class="modal-actions">
                    <el-button @click="closeModal" class="btn">取消</el-button>
                    <el-button @click="save" class="btn1">保存</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getEnumValues, createEnumValue, updateEnumValue, deleteEnumValue } from '@/utils/jdApi'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    name: 'EnumValueManagement',
    components: { quillEditor },
    data() {
        return {
            loading: false,
            items: [],
            isModalOpen: false,
            isEditMode: false,
            current: {
                noticeText: '',
                liberayIds: '',
                liberayNote: '',
                routerArr: [],
                prepareText: '',
                startText: '',
                latestActivityText: '',
                isActive: true
            },
            editingId: null,
            currentPage: 0,
            pageSize: 10,
            totalPages: 0,
            // 富文本编辑器配置
            editorOption: {
                placeholder: '请输入内容...',
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'header': [1, 2, 3, false] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'align': [] }],
                        ['link', 'image'],
                        ['clean']
                    ]
                }
            }
        }
    },
    mounted() {
        this.fetchItems()
    },
    methods: {
        async fetchItems() {
            this.loading = true
            try {
                const res = await getEnumValues({ page: this.currentPage, size: this.pageSize })
                if (res.success) {
                    this.items = res.data
                    this.totalPages = res.totalPages || 1
                } else {
                    this.$message?.error?.('加载失败')
                }
            } catch (err) {
                console.error(err)
            } finally {
                this.loading = false
            }
        },

        openAddModal() {
            this.isEditMode = false
            this.current = { noticeText: '', liberayIds: '', liberayNote: '', routerArr: [], prepareText: '', startText: '', isActive: true }
            this.isModalOpen = true
        },

        openEditModal(row) {
            this.isEditMode = true
            this.editingId = row.id
            this.current = { ...row, liberayIds: row.liberayIds.join(','), routerArr: row.routerArr ? JSON.parse(row.routerArr) : [] }
            this.isModalOpen = true
        },

        async save() {
            this.current.routerArr = JSON.stringify(this.current.routerArr);
            try {
                // 创建一个深拷贝的对象用于发送请求
                const payload = JSON.parse(JSON.stringify(this.current));
                // 如果 liberayIds 是数组，则将其转换为字符串
                if (Array.isArray(payload.liberayIds)) {
                    payload.liberayIds = payload.liberayIds.join(',');
                }
                let res
                if (this.isEditMode) {
                    res = await updateEnumValue(this.editingId, payload)
                } else {
                    res = await createEnumValue(payload)
                }
                if (res.success) {
                    this.$message.success('保存成功')
                    this.closeModal()
                    this.fetchItems()
                } else {
                    this.$message.error('保存失败')
                }
            } catch (err) {
                console.log(err);

            }
        },

        async deleteItem(id) {
            if (!confirm('确认删除？')) return
            try {
                const res = await deleteEnumValue(id)
                if (res.success) {
                    this.$message?.success?.('删除成功')
                    this.fetchItems()
                } else {
                    this.$message?.error?.('删除失败')
                }
            } catch (err) {
                console.error(err)
            }
        },

        async toggleStatus(row) {
            try {
                const payload = Object.assign({}, row)
                payload.isActive = !payload.isActive
                const res = await updateEnumValue(row.id, payload)
                if (res.success) {
                    this.$message?.success?.('操作成功')
                    this.fetchItems()
                } else {
                    this.$message?.error?.('操作失败')
                }
            } catch (err) {
                console.error(err)
            }
        },

        closeModal() {
            this.isModalOpen = false
            this.isEditMode = false
            this.editingId = null
        },

        prevPage() {
            if (this.currentPage > 0) {
                this.currentPage--
                this.fetchItems()
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++
                this.fetchItems()
            }
        },

        goBack() {
            this.$router.go(-1)
        },
        addRouter() {
            this.current.routerArr.push({ path: '', title: '', isAdminOnly: false, isShow: false })
        }
    }
}
</script>

<style scoped lang="scss">
.position-management {
    margin: 0 auto;
    padding: 10px;
    background: #f8f9fa;
    height: 100vh;
    box-sizing: border-box;
}

.header {
    background: linear-gradient(135deg, #42b983, #369870);
    color: white;
    padding: 4px;
    margin-bottom: 10px;
    flex-shrink: 0;
    border-radius: 12px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.back-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    color: white;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
    width: 20px;
    height: 20px;
}

.title {
    font-size: 18px;
    font-weight: 600;
    color: white;
}

.toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    flex-wrap: wrap;
    gap: 10px;
}

.toolbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    width: 100%;
}

.btn {
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    outline: none;
}

.btn-primary {
    background: #42b983;
    color: white;
    flex: 1;
}

.btn-primary:hover {
    background: #369870;
}

.content-table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    padding: 10px;
}

.content-table-container .el-table th {
    background: #f8f9fa;
    color: #495057;
    font-weight: 600;
    border-bottom: 2px solid #dee2e6;
}

.content-table-container .el-table td {
    border-bottom: 1px solid #f1f3f4;
}

.content-table-container .el-table tbody tr:hover {
    background-color: #f8f9fa;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px;
    background: white;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 10px;
    border-radius: 8px;
    width: 500px;
    max-width: 90vw;
    margin: 10px;

    .modal-actions {
        display: flex;
        gap: 10px;
        width: 100%;

        button {
            flex: 1;
            background: #fff;
            border: 1px solid #42b983;
            color: #42b983;
            border-radius: 4px;
        }

        .btn1 {
            background: #42b983;
            color: white;
        }
    }
}

.modal-content h3 {
    margin-top: 0;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.form-group {
    margin-bottom: 10px
}

/* 强制富文本编辑器内部高度 */
.content-quill-editor {
    width: 100%;
}

::v-deep {
    .el-tabs__header {
        margin: 0px !important;
    }

    .ql-container {
        height: 400px;
    }
}
</style>
